import type { MessageVideoPayload } from 'models';
import { Flex, VideoPlayer } from 'ui';
import { useGetMediaSource } from 'features/media';

type P = {
  videos: MessageVideoPayload[];
};

const ChatMessageBubbleVideos = ({ videos }: P) => {
  const getMediaSource = useGetMediaSource();

  return (
    <Flex className="chat-message-bubble-videos" gap="xs" vertical>
      {videos.map((videoPayload) => (
        <Flex className="chat-message-bubble-videos__item" key={videoPayload.ref}>
          <VideoPlayer controls src={getMediaSource({ id: videoPayload.ref })} />
        </Flex>
      ))}
    </Flex>
  );
};

export default ChatMessageBubbleVideos;
